import { Configuracio } from "./configuracio.model";
import { Conjunt } from "./conjunt.model";
import { GravetatRisc } from "./gravetat_risc.model";
import { Infant } from "./infant.model";
import { ResponseValoracio } from "./response_valoracio.model";
import { TipusMaltractament } from "./tipus_maltractament.model";

export class FitxaSimulacio {
    conjunts: Array<Conjunt> = [];
    gravetatRisc: GravetatRisc;
    idAmbit: number;
    infant: Infant;
    nomAmbit: string;
    respostesValoracio: ResponseValoracio;
    tipusMaltractament: Array<TipusMaltractament> = [];
    tipusMaltractamentSec: Array<TipusMaltractament> = [];
    riscNousEpisodis: Array<Configuracio> = [];
}